const DefaultVariant = require('./default')
const DrawerVariant = require('./drawer')
const DrawerNoScrollVariant = require('./drawer-no-scroll')
const ExternalLinkVariant = require('./external-link')
const AddStayVariant = require('./add-stay')
const MobileSwipeVariant = require('./mobile-swipe')
const OnboardingVariant = require('./onboarding')

const modal = {
  [DefaultVariant.name]: DefaultVariant,
  [DrawerVariant.name]: DrawerVariant,
  [DrawerNoScrollVariant.name]: DrawerNoScrollVariant,
  [ExternalLinkVariant.name]: ExternalLinkVariant,
  [AddStayVariant.name]: AddStayVariant,
  [MobileSwipeVariant.name]: MobileSwipeVariant,
  [OnboardingVariant.name]: OnboardingVariant
}

module.exports = {
  modal
}
